import ChevronLeftIcon from '../Icons/ChevronLeft'
import IconButton from './IconButton'

interface IButtonLeft {
    onClick(event?: any): void
    title?: string
}

const ButtonLeft = ({ onClick, title }: IButtonLeft) => (
    <IconButton title={title} onClick={onClick}>
        <ChevronLeftIcon data-testid="ChevronLeftIcon" />
    </IconButton>
)

export default ButtonLeft
